import {changeFieldProperty, setFieldVisibility} from "../../../../../apps/KpModule/actions";
import _ from "lodash";
import {GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api";

export const module_ = {
    name: 'Study',
    tKey: 'Étude dossier',
    object: 'ReliefFund',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: false,
    removable: false,
    viewMap: {
        dt: [
            {path: 'applicationNumber'},
            {path: 'organizationTradingName', tKey: 'tradingName'},
            {path: 'object'},
            {path: 'needsTypes', tKey: 'needs'},
            {path: 'totalTotalAmountsInEuros', tooltip: true},
            {path: 'totalRequestedAmountsInEuros', tooltip: true},
            {path: 'fundingRateForEuros'},
            //{path: 'totalTotalAmountsInKilograms', tooltip: true},
            {path: 'totalRequestedAmountsInKilograms', tooltip: true},
            //{path: 'fundingRateForKilograms'},
            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true}
        ],
        form: {
            fields: [
                {path: 'applicationNumber', editable: false},
                {path: 'organizationTradingName', tKey: 'tradingName', editable: false},
                {path: 'object', editable: false},
                {path: 'description', tKey: 'Présentation des difficultés rencontrées', type: 'richTextEditor', editable: false},
                {path: 'associationUpdatedStatutes', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false},
                {path: 'associationStatusNotice', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false},
                {path: 'latestAssociationReport', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false},
                {path: 'insuranceContract', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false},
                {path: 'bankIdentityStatement', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false},
                {
                    path: 'needs',
                    type: 'accordion',
                    newable: false,
                    viewMap: {
                        dt: [
                            { path: 'natureOfHelp', display: 'nameWithUnit', tKey: 'type'},
                            { path: 'totalAmountInEuros'},
                            { path: 'requestedAmountInEuros'},
                            //{ path: 'totalAmountInKilograms'},
                            { path: 'requestedAmountInKilograms'},
                        ],
                        form: [
                            {
                                path: 'natureOfHelp',
                                display: 'nameWithUnit',
                                tKey: 'type',
                                editable: false,
                                fieldPath: ['id', 'name', 'nameWithUnit', 'eligibleToEmergencyFund', 'facilityRelated', 'unit'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeField = needsField.viewMap.form.fields.find(field => field.path === 'landType')
                                        const totalAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'totalAmountInEuros')
                                        const requestedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInEuros')
                                        const requestedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInKilograms')

                                        store.dispatch(setFieldVisibility(landTypeField.id, !!newValue && newValue.facilityRelated))
                                        store.dispatch(setFieldVisibility(totalAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(requestedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(requestedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))
                                    }
                                }
                            },
                            {
                                path: 'landType', tKey: "Le dossier concerne un lieu", display: 'name', required: true, editable: false, translate: true, sortList: false,
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeProofField = needsField.viewMap.form.fields.find(field => field.path === 'landTypeProof')
                                        store.dispatch(setFieldVisibility(landTypeProofField.id, !!newValue))
                                        store.dispatch(changeFieldProperty(landTypeProofField.id, 'tKey', `landTypeProof_${newValue?.id}`))
                                    }
                                }
                            },
                            { path: 'totalAmountInEuros', editable: false },
                            { path: 'requestedAmountInEuros', editable: false },
                            { path: 'totalAmountInKilograms', editable: false, hidden: true },
                            { path: 'requestedAmountInKilograms', editable: false },
                            { path: 'landTypeProof', required: true, fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false, hidden: true },
                            { path: 'supportingDocuments', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', tKey: "needSupportingDocuments_submission", editable: false}
                        ]
                    }
                },
                {path: 'associationInformationUpToDate', editable: false},
                {path: 'shelterInformationUpToDate', editable: false},
                {path: 'shelterCapacityInformationUpToDate', editable: false},
                {path: 'statementOfHonestyAndAccuracy', editable: false},
                {
                    path: 'ongoingLiberalities',
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module, formInitialize, getObjectSuccessAction}) => {
                            store.dispatch(setFieldVisibility('e_currentSuccessionsName', !!newValue))
                            store.dispatch(setFieldVisibility('e_estimatedAmount', !!newValue))
                            if(!newValue && (!formInitialize && !getObjectSuccessAction)) {
                                const currentSuccessionsNameField = module.viewMap.form.fields.find(field => field.path === 'currentSuccessionsName')
                                const estimatedAmountField = module.viewMap.form.fields.find(field => field.path === 'estimatedAmount')
                                currentSuccessionsNameField.setValue('')
                                estimatedAmountField.setValue(null)
                            }
                        }
                    }
                },

                {path: 'currentSuccessionsName', required: true},
                {path: 'estimatedAmount', wholeNumber: true, required: true},
                /*
                {path: 'files', tKey: 'Fichiers', editable: false},
                 */
                {path: 'studyCommitteeComment', type: 'richTextEditor'},
                {path: 'conversations', tKey: "interactionZone"},
                {path: 'submitter', fieldPath: ['id', 'firstname', 'lastname', 'mail'], hidden: true},
                {path: 'organization', fieldPath: ['id', 'name', 'hasShelters'], hidden: true},
                {path: 'buttons', hidden: true}
            ]
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store }) => {
                const state = store.getState()
                const orgHasShelters = _.get(state, 'edit.object.data.organization.hasShelters')

                store.dispatch(setFieldVisibility( 'e_shelterInformationUpToDate', orgHasShelters))
                store.dispatch(setFieldVisibility( 'e_shelterCapacityInformationUpToDate', orgHasShelters))
            }
        }
    ],
    filters: [
        'userHasAuthorization',
        {
            path: 'byStatusForStudy',
            query: () => {
                return { status: {$in: ['ongoing', 'updated']}}
            }
        }
    ]
}
